import AdvertisementForm from './AdvertisementForm';

const CreateAdvertisement = () => <AdvertisementForm mode="create" />;

export default CreateAdvertisement;
